export default function(selector) {
  return document.querySelector(selector);
}



// WEBPACK FOOTER //
// ./scripts/lib/query.js